var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/company"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.905 22.639v-6.492c0-.608.496-1.102 1.108-1.102H9.23c.612 0 1.108.494 1.108 1.102v6.492m0-12.817c0 .609-.496 1.102-1.108 1.102H7.013a1.105 1.105 0 0 1-1.108-1.102V6.395c0-.609.496-1.102 1.108-1.102H9.23c.612 0 1.108.493 1.108 1.102v3.427Zm4 8.529v-2.204c0-.608.497-1.102 1.109-1.102h1.552c.613 0 1.109.494 1.109 1.102v2.204h-3.77Zm-.436-8.193V2.242a1 1 0 0 0-1-1H6.318a4 4 0 0 0-4 4v15.516a2 2 0 0 0 2 2h15.364a2 2 0 0 0 2-2v-7.6a2 2 0 0 0-2-2h-4.78a1 1 0 0 1-1-1Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.6b4587cd509e238eb90ccd4d0fb9d356.svg";
export { ForwardRef as ReactComponent };